<form class="form" 
#twofaForm="ngForm"
(ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-md-3">

          <mat-checkbox
            class="example-margin"
            #twofacheck
            [checked]="allComplete"
            (change)="setAll($event.checked)"
            [(ngModel)]="twofaFormValue.is_2fa"
            name="2fa"
          >
            <div
              *ngIf="twofacheck.checked; then thentwofaBlock; else elsetwofaBlock"
            ></div>

            <ng-template #thentwofaBlock>Enabled 2FA</ng-template>
            <ng-template #elsetwofaBlock>Enable 2FA</ng-template>
          </mat-checkbox>
      
          
    </div>
  </div>
  <div style="text-align: center">
    <button 
    type="submit" mat-raised-button class="btn btn-primary" color="primary">
      Save
    </button>
    &nbsp;&nbsp;&nbsp;
    <a
      (click)="cancelClick()"
      mat-raised-button
      class="btn btn-light-primary btn-bold"
    >
      Cancel
    </a>
  </div>
</form>
